import React, { useState, useEffect } from 'react';
import classes from "./checkout.module.css";
import { sixYardAxios } from '../../../../sixYardAxios';
import DoubleArrow from "../../../../assets/images/red-arrow.png";
import PromptMessage from '../../../containers/promptMessage/promptMessage';
import { fetchUserProfile, authCheckState } from "../../../../store/actions";
import { connect } from 'react-redux';
const Checkout = (props) => { 
    const initialTotalAmount = Number(props.paymentData?.registration_details?.amounts?.total) || 0;
    const [loyaltyPointsUsed, setLoyaltyPointsUsed] = useState(0);
    const [partialValue, setPartialValue] = useState(10);
    const [loyalty, setLoyalty] = useState(0);
    const [checkLoyaltyEnteredAmount, setCheckLoyaltyEnteredAmount] = useState(null);
    const [error, setError] = useState(null);
    const [totalAmount, setTotalAmount] = useState(initialTotalAmount);
    const [paymentType, setPaymentType] = useState("full");
    const [loading, setLoading] = useState(null);
    useEffect(() => {
        props.onCheckAuth();
        if (props.isAuthenticated) props.onGetProfile();
    }, []);
    useEffect(() => {
        if (props.isAuthenticated) props.onGetProfile();
    }, [props.isAuthenticated]);
    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                registration_id: props.registrationId,
                amount: paymentType === "full" ? totalAmount : partialValue,
                payment_type: paymentType,
                loyalty_points_used: loyaltyPointsUsed,
                "customer_name": "",
                "customer_email": ""
            }
            const response = await sixYardAxios.post('/payments/initiate/camp', formData);
            if (response.data.data) {
                const redirectUrl = response.data.data.redirect_url;
                localStorage.removeItem("campRegistrationFormPackage");
                localStorage.removeItem("campRegistrationFormLegalInfo");
                localStorage.removeItem("campRegistrationFormWaiver");
                props.setShowCampRegistrationForm(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                redirectUrl != null && window.open(redirectUrl, '_blank');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const backHandler = () => {
        props.setCurrentStep(props.currentStep - 1)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    const calculateLoyaltyAmount = (e) => {
        if (e.target.value <= props.userData?.loyalty?.points) {
            setLoyalty(e.target.value);
        }
        else {
            setCheckLoyaltyEnteredAmount("The amount you enter greater than your points");
        }
    }
    const closeLoyaltyIssue = () => {
        setCheckLoyaltyEnteredAmount(null)
        setLoyalty("");
    }
    const loyaltySubmitHandler = (e) => {
        e.preventDefault();
        setLoyaltyPointsUsed(loyalty)
        setTotalAmount(initialTotalAmount - loyalty)
    }
    return (
        <div className={classes.Container}>
            <div className={classes.Content}>
                <div className={classes.Note}>
                    <div className={classes.NoteIcon}>i</div>
                    <div>JOD 50 registration fees and welcoming kit including t-shirts, water bottle, and cap to be paid at our premises when registering for the first time.</div>
                    </div>
                <div className={classes.BookingSummery}>
                    <h3>Booking Summary</h3>
                    <div className={classes.info}>
                        <p>{props.paymentData?.registration_details?.package?.name}</p>
                        <p>{props.paymentData?.registration_details?.camp?.name}</p>
                        {props.paymentData?.registration_details?.participants && (
                            <p>Participants: {props.paymentData?.registration_details?.participants.map(p => p.name).join(', ')}</p>
                        )}
                        {props.bookingData?.start_date && props.bookingData?.end_date && (
                            <p>Booked Dates: {props.bookingData?.start_date} - {props.bookingData?.end_date}</p>
                        )}
                    </div>
                    <div>
                        You have
                        <span className={classes.money}> {props.userData?.loyalty?.points} JD </span>
                        from loyalty program, enter the amount you desire to use.
                    </div>
                    <form onSubmit={(e) => loyaltySubmitHandler(e)}>
                        <label>Amount</label><br />
                        <input placeholder='Enter amount' value={loyalty}
                            onChange={(e) => calculateLoyaltyAmount(e)} />
                        <button type='submit'>Calculate</button>
                    </form>
                </div>
                <div className={classes.PaymentSummery}>
                    <h3>Payment Summary</h3>
                    <div>
                        <span>{props.paymentData.registration_details?.package?.name}</span>
                        <span>{Number(props.paymentData?.registration_details?.amounts?.subtotal) - 
                          (props.paymentData?.registration_details?.extra_services?.reduce((acc, service) => 
                            acc + Number(service.price), 0) || 0)} JD</span>
                    </div>
                    {props.paymentData?.registration_details?.extra_services?.length > 0 && 
                        props.paymentData?.registration_details?.extra_services.map((service, index) => (
                            <div key={index}>
                                <span>{service.name}</span>
                                <span>{service.price} JD</span>
                            </div>
                        ))
                    }
                    {props.paymentData?.registration_details?.amounts?.welcome_kit_required && <div>
                        <span>Welcoming Kit</span>
                        <span>{props.paymentData?.registration_details?.amounts?.welcome_kit_price} JD</span>
                    </div>}
                    {props.paymentData?.registration_details?.amounts?.loyalty_discount > 0 && <div>
                        <span>Discount</span>
                        <span className={classes.Zero}>-{props.paymentData?.registration_details?.amounts?.loyalty_discount} JD</span>
                    </div>}
                    <div className={classes.LoyaltyPoints}>
                        <span>Loyalty Program Points</span>
                        <span className={classes.Zero}>{loyaltyPointsUsed === "" ? 0 : loyaltyPointsUsed} JD</span>
                    </div>
                    <div className={classes.Total}>
                        <span>Total</span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>
                <div>
                    <h3>Payment Amount</h3>
                    <div className={classes.Note}>
                        <div className={classes.NoteIcon}>i</div>
                        <div>You can pay full amount</div>
                    </div>
                    {/* <div className={classes.Radio}>
                        <span>
                            <input type="radio" checked={paymentType === "partial"} value="partial"
                                onChange={() => setPaymentType("partial")} />
                            <label className={classes.Label}>Down Payment</label>
                        </span>
                        <span>{partialValue} JD</span>
                    </div> */}
                    <div className={classes.Radio}>
                        <span>
                            <input type="radio" checked={paymentType === "full"} value="full"
                                onChange={() => setPaymentType("full")} />
                            <label className={classes.Label}>Full Amount</label>
                        </span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>
                <div>
                    <form className={classes.FormContainer} onSubmit={(e) => submitHandler(e)}>
                        <div className={classes.Buttons}>
                            <button onClick={backHandler}>
                                <img
                                    src={DoubleArrow}
                                    alt=""
                                    className={classes.Icon}
                                /> BACK
                            </button>
                            <button type="submit">
                                CHECKOUT
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
            {checkLoyaltyEnteredAmount && <PromptMessage message={checkLoyaltyEnteredAmount} status='Oops' button='CLOSE' click={closeLoyaltyIssue} />}
        </div >
    )
}
const mapStateToProps = state => ({
    userData: state.profile.userProfile,
    isAuthenticated: state.auth.token !== null,
});
const mapDispatchToProps = dispatch => {
    return {
        onGetProfile: () => {
            dispatch(fetchUserProfile());
        },
        onCheckAuth: () => {
            return dispatch(authCheckState());
        },
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Checkout);
